import styled, { css } from 'styled-components';
import { ReactComponent as EmptyTableMobileSvg } from 'src/assets/emptyMyTicketsTableMobile.svg';
import { ReactComponent as EmptyFiltersTableSvg } from 'src/assets/emptyFiltersMyTicketsTable.svg';
import { PrimaryButton } from 'src/styles/globalStyles/buttonStyles.styled';

export const LayoutWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: max-content 1fr auto;
  grid-template-areas:
    'Header'
    'Table'
    'Footer';
  height: 100%;
`;

export const HeaderWrapper = styled.div`
  grid-area: Header;
`;

export const TicketsContainer = styled.div`
  grid-area: Table;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 7px 16px;
  overflow: auto;
`;

export const FooterWrapper = styled.div`
  grid-area: Footer;
  margin-top: 100px;
`;

export const EmptyStateLayout = styled.div`
  position: relative;
  height: 100%;
`;

export const EmptyStateContainer = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  overflow-y: auto;
  padding: 0px 48px;
  min-height: 100vh;
  height: auto;
  bottom: 0px;
`;

const EmptyTableIcon = css`
  width: 100%;
  height: 100%;
`;

export const NoTicketsIcon = styled(EmptyTableMobileSvg)`
  ${EmptyTableIcon}
`;

export const NoFiltersMatchIcon = styled(EmptyFiltersTableSvg)`
  ${EmptyTableIcon}
`;

export const ButtonNewTicket = styled(PrimaryButton)`
  grid-area: buttonNewTicket;
  border: 2px solid transparent;
  width: max-content;
  border-radius: 100px;
  padding: 8px 10px;
  gap: 4px;
  align-content: center;
  &.footerInViewPort {
    display: flex;
    align-items: center;
  }
  &.footerOutOfViewPort {
    position: fixed;
    bottom: 50px;
    right: 20px;
  }
`;
